import * as React from "react";
import ClipLoader from "react-spinners/ClipLoader";

export class Loader extends React.Component<any, any> {
    render() {
        return (
            <div className="loader-wrapper">
                <ClipLoader color={'#1976d2'} size={50} />
                <div className="loader-text">
                    Učitavamo podatke, molimo vas sačekajte...
                </div>
            </div>
        )
    }
}